"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 02 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var PriceDistance_1 = require("../../model/price-distance/PriceDistance");

var StrategySettings_1 = require("../../model/strategy/StrategySettings");

var StrategyTypeEnum_1 = require("../../model/strategy/StrategyTypeEnum");

var RangeConverter_1 = require("../constraint/RangeConverter");

var StrategyConverterResolver_1 = require("./StrategyConverterResolver");

var StrategySettingsConverter_1 = require("./StrategySettingsConverter");
/**
 * Default implementation of {@link StrategySettingsConverter}.
 *
 * @author RV
 */


var StrategySettingsConverterImpl =
/*#__PURE__*/
function (_StrategySettingsConv) {
  _inherits(StrategySettingsConverterImpl, _StrategySettingsConv);

  function StrategySettingsConverterImpl(strategyConverterResolver, rangeConverter) {
    var _this;

    _classCallCheck(this, StrategySettingsConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StrategySettingsConverterImpl).call(this));
    _this.strategyConverterResolver = strategyConverterResolver;
    _this.rangeConverter = rangeConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(StrategySettingsConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new StrategySettings_1.StrategySettings(conversions.asObjectOpt(source, 'priceDistance', function (doc) {
        return new PriceDistance_1.PriceDistance(_this2.rangeConverter.toObject(doc.range, conversions));
      }), conversions.asObjectOpt(source, 'strategy', function (strategyDocument) {
        return _this2.strategyConverterResolver.resolve(conversions.asEnum(strategyDocument.strategyType, StrategyTypeEnum_1.StrategyTypeEnum)).toObject(strategyDocument, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        priceDistance: source.priceDistance != null ? {
          range: this.rangeConverter.toDocument(source.priceDistance.range, conversions)
        } : null
      });
      Object.assign(result, {
        strategy: conversions.asObjectOpt(source, 'strategy', function (strategy) {
          return _this3.strategyConverterResolver.resolve(strategy.getType()).toDocument(strategy, conversions);
        })
      });
      return result;
    }
  }]);

  return StrategySettingsConverterImpl;
}(StrategySettingsConverter_1.StrategySettingsConverter);

StrategySettingsConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [StrategyConverterResolver_1.StrategyConverterResolver, RangeConverter_1.RangeConverter])], StrategySettingsConverterImpl);
exports.StrategySettingsConverterImpl = StrategySettingsConverterImpl;